import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../context-store";
import Layout from "../../components/layout/Layout";
import "../../assets/InnerCSS/plugins/bootstrap/css/bootstrap.min.css";
import "../../assets/InnerCSS/plugins/font-awesome/css/font-awesome.min.css";
import "../../assets/InnerCSS/plugins/icomoon/style.css";
import "../../assets/InnerCSS/plugins/uniform/css/default.css";
import "../../assets/InnerCSS/plugins/switchery/switchery.min.css";
import "../../assets/InnerCSS/plugins/nvd3/nv.d3.min.css";
import "../../assets/InnerCSS/css/styles.css";
import "../../assets/InnerCSS/css/custom.css";
import { useParams } from "react-router-dom";
import JobPostingParams from "../../models/common/PageParms";
import JobPostingInterviewProcessComponent from "../../components/company/job-posting-interview-process/JobPostingInterviewProcessComponent";
import CompanyConfigurationModel from "../../models/company/CompanyConfigurationModel";
import JobPostingRequestModel from "../../models/company/jobPosting/request/JobPostingRequestModel";
import { GuidEnum } from "../../models/enums/GuidEnum";
import IdNameModel from "../../models/common/IdNameModel";
import jobPostingService from "../../services/company/job-posting-service";
import toasterUtils from "../../utils/toaster-utils";
import masterDataService from "../../services/master-data-service";
import modalUtils from "../../utils/modal-utils";
import { InterviewTypeEnum } from "../../models/enums/InterviewTypeEnum";
import { useHistory } from "react-router";

var companyConfigurationDefault: CompanyConfigurationModel = {
    companyId: "",
    countryId: 1
};

var jobPostingRequestModelDefault: JobPostingRequestModel = {
    addInterviewProcess: false,
    additionalSkills: "",
    assessmentName: "",
    captureScreenShot: true,
    cityId: null,
    companyId: GuidEnum.Empty,
    designationId: GuidEnum.Empty,
    domainId: null,
    endDate: new Date(),
    startDate: new Date(),
    highestPay: "",
    interviewTypeId: null,
    jobCode: "",
    jobDescription: "",
    jobPostingSkillRequestModel: [],
    jobTypeId: null,
    keyResponsibilities: "",
    maxExperienceId: null,
    minExperienceId: null,
    minRatingForSelection: 0,
    isCalibrationCallCompleted: false,
    isClientApproved: false,
    panelsAvailable: false,
    primarySkillId: null,
    recruiterId: GuidEnum.Empty,
    requirementId: GuidEnum.Empty,
    scheduleZoomInterview: true,
    sendMailToRecruiter: true,
    statusId: null,
    userId: GuidEnum.Empty,
};

const JobPostingInterviewProcess = () => {
    const history = useHistory();
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const requestParams: JobPostingParams = useParams();
    const [companyConfiguration, setCompanyConfiguration] = useState<CompanyConfigurationModel>(companyConfigurationDefault);
    const [jobPostingRequestModel, setJobPostingRequestModel] = useState<JobPostingRequestModel>(jobPostingRequestModelDefault);
    const [secondarySkillList, setSecondarySkillList] = useState<IdNameModel[]>([]);
    const [interviewRoundList, setSnterviewRoundList] = useState<IdNameModel[]>([]);

    useEffect(() => {
        //getCompanyConfiguration();
        getJobPostingById(requestParams.requirementId);
    }, []);

    // const getCompanyConfiguration = () => {
    //     if (loggedInUser) {
    //         jobPostingService.getCompanyConfiguration(loggedInUser.userId).then((res) => {
    //             if (!res.isSuccess || res.errorMessages.length > 0) {
    //                 toasterUtils.showError(res.errorMessages.toString());
    //                 return;
    //             }
    //             setCompanyConfiguration(res.data);
    //         }).catch((error) => {
    //             toasterUtils.showError(error);
    //         });
    //     }
    // };

    const getJobPostingById = (requirementId: string) => {
        modalUtils.showLoader();
        jobPostingService.getJobPostingById(requirementId).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }            
            setJobPostingRequestModel(res.data);
            let companyConfig: CompanyConfigurationModel = {
                companyId: res.data.companyId,
                countryId: 1
            };
            setCompanyConfiguration(companyConfig);
            setCompanyConfiguration(companyConfig);
            loadSecondarySkills(res.data.primarySkillId);
            loadInterviewRounds(res.data.interviewTypeId);
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    const loadSecondarySkills = (primarySkillId: number | null) => {
        if (primarySkillId !== 0 && primarySkillId !== null) {
            modalUtils.showLoader();
            masterDataService.loadSecondarySkills(primarySkillId).then((res) => {
                modalUtils.closeModal();
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                setSecondarySkillList(res.items);
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError("Erorr fetching Primary skills");
            });
        } else {
            toasterUtils.showError("Please Select Primary Skill");
        }
    };

    const loadInterviewRounds = (interviewTypeId: number | null) => {
        masterDataService.loadInterviewRounds().then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            if (interviewTypeId !== null && interviewTypeId === Number(InterviewTypeEnum.CodeTest)) {
                setSnterviewRoundList(res.items);
            } else {
                setSnterviewRoundList(res.items.filter(x => x.id != 10));
            }
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    return (
        <Layout>
            <div className="breadcrumb-text">
                <a onClick={() => history.push("/")}>Home</a> <i className="fa-solid fa-angle-right"></i> <a onClick={() => history.push("/job-posting")}>Post Job</a> <i className="fa-solid fa-angle-right"></i> Interview Process
            </div>
            <div className="page-title">
                <h4 className="breadcrumb-header"> Interview Process </h4>
            </div>
            {secondarySkillList.length > 0 && interviewRoundList.length > 0 &&
                <JobPostingInterviewProcessComponent
                    companyConfiguration={companyConfiguration}
                    jobPostingRequestModel={jobPostingRequestModel}
                    secondarySkillList={secondarySkillList}
                    interviewRoundList={interviewRoundList} />
            }
        </Layout>
    );
};
export default JobPostingInterviewProcess;